/**
 * Progress for one file upload. Slow phone connections can take a while to
 * send an image; a moving bar shows the tap worked and the upload is alive.
 */
export function UploadProgressBar({ percent, label }: { percent: number; label?: string }) {
  const sent = percent >= 100;
  return (
    <div
      className="w-full max-w-xs space-y-1"
      role="progressbar"
      aria-label={label ? `Uploading ${label}` : "Uploading"}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
    >
      <div className="h-1.5 overflow-hidden rounded-full bg-foreground/10">
        <div
          className="h-full rounded-full bg-brand transition-[width] duration-200 motion-reduce:transition-none"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground">
        {label ? `${label} · ` : ""}
        {sent ? "Processing…" : `Uploading… ${percent}%`}
      </p>
    </div>
  );
}
